// src/pages/PainelChamados/CamposFormulario.jsx
import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import DatePicker from "./DatePicker";
import TimePicker from "./TimePicker";

const API_URL = process.env.REACT_APP_API_URL; // CRA usa prefixo REACT_APP_

export default function CamposFormulario({
  tipoServico,
  setTipoServico,
  finalizadoEm,
  setFinalizadoEm,
}) {
  const hoje = new Date();
  const dataHoje = hoje.toLocaleDateString("pt-BR");
  const horaAgora = hoje.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const [dataAbertura, setDataAbertura] = useState(dataHoje);
  const [horaAbertura, setHoraAbertura] = useState(horaAgora);
  const [opcoesServico, setOpcoesServico] = useState([]);
  const [openServico, setOpenServico] = useState(false);

  const refServico = useRef(null);

  // 🔹 Carrega lista da API
  useEffect(() => {
    const carregarServicos = async () => {
      try {
        const resp = await fetch(`${API_URL}/tipo-servico/listar.php`);
        if (!resp.ok) throw new Error(`HTTP error! status: ${resp.status}`);
        const json = await resp.json();

        console.log("🔎 Retorno da API:", json);

        if (json && Array.isArray(json.dados)) {
          setOpcoesServico(json.dados);
        } else {
          setOpcoesServico([]);
        }
      } catch (error) {
        console.error("Erro ao carregar serviços:", error);
        setOpcoesServico([]);
      }
    };
    carregarServicos();
  }, []);

  // 🔹 Fecha dropdown ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (refServico.current && !refServico.current.contains(e.target)) {
        setOpenServico(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const inputBaseClasses = `
    peer w-full h-10 px-2 border-b-[1px] border-gray-300
    focus:border-blue-600 focus:ring-0 focus:outline-none
    text-base text-gray-900 bg-transparent placeholder-transparent
  `;

  const labelBaseClasses = (value) => `
    absolute left-2 transition-all duration-200 pointer-events-none
    ${
      value
        ? "-top-4 text-sm font-bold text-gray-900"
        : "top-2 text-base text-gray-500"
    }
    peer-focus:-top-4 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900
  `;

  return (
    <div className="p-6 flex flex-wrap gap-6 items-end">
      <DatePicker
        label="Data de Abertura"
        value={dataAbertura}
        onChange={setDataAbertura}
      />
      <TimePicker
        label="Hora"
        value={horaAbertura}
        onChange={setHoraAbertura}
      />

      {/* Data de Finalização */}
      <div className="relative w-44">
        <input
          type="text"
          value={finalizadoEm}
          onChange={(e) => setFinalizadoEm(e.target.value)}
          placeholder=" "
          className={inputBaseClasses}
        />
        <label className={labelBaseClasses(finalizadoEm)}>
          Data de Finalização
        </label>
      </div>

      {/* Tipo de Serviço */}
      <div className="relative flex-1 min-w-[250px]" ref={refServico}>
        <input
          type="text"
          value={tipoServico}
          onClick={() => setOpenServico((p) => !p)}
          readOnly
          placeholder=" "
          className={inputBaseClasses + " cursor-text"} // 🔥 somente leitura
        />
        <label className={labelBaseClasses(tipoServico)}>Tipo de Serviço</label>

        {/* Ícone setinha */}
        <ChevronDown
          size={16}
          className={`absolute right-1 top-3 transition-transform ${
            openServico ? "rotate-180" : "rotate-0"
          }`}
        />

        <AnimatePresence>
          {openServico && (
            <motion.ul
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.2 }}
              className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 
                         rounded-md shadow-md z-10 max-h-52 overflow-y-auto"
            >
              {opcoesServico.length > 0 ? (
                opcoesServico.map((s) => (
                  <li
                    key={s.id}
                    onMouseDown={() => {
                      setTipoServico(s.nome);
                      setOpenServico(false);
                    }}
                    className="px-3 py-2 text-sm text-gray-700 hover:bg-blue-100 cursor-pointer"
                  >
                    {s.nome}
                  </li>
                ))
              ) : (
                <li className="px-3 py-2 text-sm text-gray-500">
                  Nenhum serviço encontrado
                </li>
              )}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
